import { useContext, useState } from 'react';
import AuthContext from './Auth';
import { useHistory } from 'react-router';
import styles from '../css/Login.module.scss';
import Header from './Header';
import AlertContext from './Alert';
import {
  Avatar,
  Grid,
  Paper,
  TextField,
  Button,
  Typography,
  Link,
} from '@material-ui/core';
import { AccountCircle } from '@material-ui/icons';
import apiUrl from '../assets/apiUrl';

const Signup = () => {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const history = useHistory();
  const { login: performLogin, signup } = useContext(AuthContext);
  const { show } = useContext(AlertContext);
  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      if (password !== repeatPassword)
        throw new Error('The passwords are different');
      await signup({ firstName, lastName, email, password });
      setIsOtpOpen(true);
    } catch (error: any) {
      show({ title: 'Signup error', body: error, type: 'error' });
    }
  };
  const paperStyle = {
    padding: 20,
    width: 280,
    margin: '20px auto',
  };
  const [isOtpOpen, setIsOtpOpen] = useState(false);
  const [otpCode, setOtpCode] = useState('');
  const otpSubmit = async (e: any) => {
    e.preventDefault();
    await fetch(`${apiUrl}/auth/register/otp?email=${email}&code=${otpCode}`, {
      method: 'POST',
    });
    await performLogin(email, password);
    history.push('/');
  };
  return (
    <div className="homepage">
      <Header />
      <div className={styles.Login}>
        <Grid>
          <Paper elevation={10} style={paperStyle}>
            <Grid container spacing={0} direction="column" alignItems="center">
              <Avatar style={{ backgroundColor: '#f6690c' }}>
                <AccountCircle />
              </Avatar>
              <h2>Sign Up</h2>
            </Grid>
            <form onSubmit={(e) => (isOtpOpen ? otpSubmit(e) : onSubmit(e))}>
              {!isOtpOpen && (
                <>
                  <TextField
                    label="first name"
                    placeholder="enter your first name"
                    fullWidth
                    required
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                  <TextField
                    label="last name"
                    placeholder="enter your last name"
                    fullWidth
                    required
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                  <TextField
                    label="email"
                    placeholder="enter your email"
                    fullWidth
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <TextField
                    label="password"
                    placeholder="enter your password"
                    type="password"
                    fullWidth
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <TextField
                    label="repeat password"
                    placeholder="repeat your password"
                    type="password"
                    fullWidth
                    required
                    value={repeatPassword}
                    onChange={(e) => setRepeatPassword(e.target.value)}
                  />
                </>
              )}
              {isOtpOpen && (
                <>
                  <Typography>
                    Type the OTP code you received at:
                    {` ${email}`}
                  </Typography>
                  <TextField
                    label="OTP code"
                    placeholder="OTP code"
                    fullWidth
                    value={otpCode}
                    onChange={(e) => setOtpCode(e.target.value)}
                  />
                </>
              )}
              <Button
                type="submit"
                color="primary"
                variant="contained"
                fullWidth
                onClick={(e) => (isOtpOpen ? otpSubmit(e) : onSubmit(e))}
                style={{ marginTop: '16px' }}
              >
                {isOtpOpen ? 'Complete registration' : 'Sign Up'}
              </Button>
            </form>
            <Typography style={{ margin: '16px 0' }}>
              <Link href="login">Login instead</Link>
            </Typography>
          </Paper>
        </Grid>
      </div>
    </div>
  );
};

export default Signup;
